export enum ConditionStatus {
  NOT_TESTED = 1,
  OK = 2,
  WARNING = 3,
  NOT_OK = 4
}
